import React, { type FC } from 'react'
import { Box, Typography } from '@mui/material'

import { StatusType } from '../../../domain'

import { Status } from '../common'

const wrapperStyle = { display: 'flex', flexWrap: 'wrap', gap: 2 } as const

export const Statuses: FC = () => (
    <>
        <Typography variant="subtitle1" sx={{ display: 'block', mb: 4 }}>
            Status
        </Typography>
        <Box sx={wrapperStyle}>
            {Object.values(StatusType).map((status) => <Status key={status} status={status} />)}
        </Box>
    </>
)
